import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../../lib/api";

export const useSpeakPublic = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/speak").then(({ data }) => setD(data)).catch(() => {}); }, []);
  return d;
};

export const SpeakTopics = ({ topics = [] }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 font-round" data-testid="speak-topics-showcase">
    {topics.map((t, i) => (
      <motion.div key={t.topic_id} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.06 }}
        className="rounded-2xl overflow-hidden bg-white border-2" style={{ borderColor: `${t.color}55` }} data-testid={`speak-showcase-${t.topic_id}`}>
        <div className="relative h-24">
          <img src={t.cover_image} alt="" className="w-full h-full object-cover" />
          <span className="absolute top-2 left-2 w-8 h-8 rounded-full text-white flex items-center justify-center text-sm" style={{ background: t.color }}>{i + 1}</span>
        </div>
        <div className="p-3">
          <div className="text-xl" style={{ color: t.color }}>{t.emoji} {t.title}</div>
          <ul className="mt-1 text-stone-600 text-sm space-y-0.5">{t.samples.map((x) => <li key={x}>「{x}」</li>)}</ul>
          <div className="text-xs text-stone-400 mt-1">共 {t.count} 句</div>
        </div>
      </motion.div>
    ))}
  </div>
);
